import { BuildUrlParams } from "models/convention-api/types"
import { useMemo, useState } from "react"

export const useVideosSearch = () => {
  const [query, setQuery] = useState("")
  const [tagIds, setTagIds] = useState<string[]>([])

  const filter: BuildUrlParams["filter"] = useMemo(() => {
    if (query.length === 0 && tagIds.length === 0) return undefined

    return {
      q: query,
      tag_id: tagIds,
    }
  }, [query, tagIds])

  return {
    query,
    setQuery,
    tagIds,
    setTagIds,
    filter,
  }
}
